// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"682":"78466c44","757":"4ab797c0"}[chunkId] + ".chunk.css";
};